import { render, staticRenderFns } from "./OurOfferTabs.vue?vue&type=template&id=07cc7440&scoped=true&"
import script from "./OurOfferTabs.vue?vue&type=script&lang=js&"
export * from "./OurOfferTabs.vue?vue&type=script&lang=js&"
import style0 from "./OurOfferTabs.vue?vue&type=style&index=0&id=07cc7440&lang=scss&scoped=true&"
import style1 from "./OurOfferTabs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc7440",
  null
  
)

export default component.exports